import ApiGenericServicesData from "service/ApiGenericServicesData";
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class ConstanciaDirectivoMandatarioOrganizacionPolitica extends ApiGenericServicesData {
  constructor() {
    super("constanciaDirectivoMandatarioOrganizacionPolitica");
  }

  async openFile(fileName) {
    const fileNameSeguro = await codificarValorSeguro(fileName);
    return this.customGET("openFile/" + fileNameSeguro);
  }
}
